import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <link
        href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />

      {/* Header */}
      <header className="border-b border-gray-200" style={{ backgroundColor: '#102A43' }}>
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-7 h-7 flex items-center justify-center rounded bg-white/20">
              <i className="ri-time-line text-white text-sm"></i>
            </div>
            <span className="text-base font-bold text-white tracking-tight">AI納期</span>
          </Link>
          <span className="text-sm text-blue-200">プライバシーポリシー</span>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">プライバシーポリシー</h1>
        <p className="text-sm text-gray-500 mb-8">制定日：2025年4月1日　／　最終更新日：2025年4月1日</p>

        <div className="space-y-8 text-sm text-gray-700 leading-relaxed">

          {/* Intro */}
          <p>
            個人事業主 小助川（以下「運営者」）は、サービス「AI納期」（iOSアプリ及びWebサービス。以下「本サービス」）において収集するユーザーの個人情報について、以下のとおり定めます。
          </p>

          <Section title="1. 収集する情報">
            <p className="mb-3">本サービスでは以下の情報を収集します。</p>
            <ul className="space-y-1.5 pl-4">
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span>氏名・担当者名、メールアドレス、会社名（ユーザーが入力した情報）</li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span>IPアドレス、デバイス種別・OSバージョン、アクセス日時</li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span>納期・配送・発注などの業務データ</li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span>OCR処理のために撮影・アップロードした納品書・FAX等の画像データ</li>
            </ul>
            <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <p className="font-semibold text-gray-800 mb-2 text-xs uppercase tracking-wide">iOSアプリのデバイス機能アクセス</p>
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="text-left px-3 py-2 border border-gray-200 font-semibold text-gray-600">機能</th>
                      <th className="text-left px-3 py-2 border border-gray-200 font-semibold text-gray-600">用途</th>
                      <th className="text-left px-3 py-2 border border-gray-200 font-semibold text-gray-600 whitespace-nowrap">任意/必須</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ['カメラ', '納品書・FAX等のAI読み取り（OCR）のための撮影', '任意'],
                      ['フォトライブラリ', '保存済み画像からのOCR処理', '任意'],
                      ['プッシュ通知', '入荷ステータス変更・発注承認等の通知', '任意'],
                    ].map(([func, usage, type], i) => (
                      <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="px-3 py-2 border border-gray-200 font-medium whitespace-nowrap">{func}</td>
                        <td className="px-3 py-2 border border-gray-200">{usage}</td>
                        <td className="px-3 py-2 border border-gray-200 whitespace-nowrap">{type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="text-xs text-gray-500 mt-2">これらへのアクセスはユーザーが任意に許可・拒否できます。拒否した場合でも基本機能は引き続きご利用いただけます。</p>
            </div>
          </Section>

          <Section title="2. 情報の利用目的">
            <ul className="space-y-1.5 pl-4">
              {[
                '本サービスの提供・運営・改善',
                '本人確認・認証',
                'サービスに関する重要なお知らせの送付',
                'お問い合わせへの対応',
                '不正アクセス・不正利用の防止',
                'サービスの品質向上のための統計・分析',
                'OCR処理（AIによる納品書・FAX等の読み取り）の実行',
              ].map((item, i) => (
                <li key={i} className="flex gap-2">
                  <span className="text-gray-400 flex-shrink-0">・</span>{item}
                </li>
              ))}
            </ul>
          </Section>

          <Section title="3. 第三者への提供">
            <p className="mb-3">運営者は、以下の場合を除き、ユーザーの個人情報を第三者に提供しません。</p>
            <ul className="space-y-1.5 pl-4 mb-4">
              {[
                'ユーザー本人の同意がある場合',
                '法令に基づく開示が必要な場合',
                '人の生命・財産の保護のために緊急の必要がある場合',
                '業務委託先への提供（守秘義務を課した上で必要な範囲に限定）',
              ].map((item, i) => (
                <li key={i} className="flex gap-2">
                  <span className="text-gray-400 flex-shrink-0">・</span>{item}
                </li>
              ))}
            </ul>
            <p className="font-semibold text-gray-800 mb-2">利用する外部サービス（データ処理委託先）</p>
            <div className="overflow-x-auto">
              <table className="w-full text-xs border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="text-left px-3 py-2 border border-gray-200 font-semibold text-gray-600">サービス</th>
                    <th className="text-left px-3 py-2 border border-gray-200 font-semibold text-gray-600">目的</th>
                    <th className="text-left px-3 py-2 border border-gray-200 font-semibold text-gray-600">プライバシーポリシー</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ['OpenAI', '画像OCR・AI分析処理', 'https://openai.com/privacy', 'openai.com/privacy'],
                    ['Vercel', 'サーバーホスティング', 'https://vercel.com/legal/privacy-policy', 'vercel.com/legal/privacy-policy'],
                    ['Apple App Store', 'iOSアプリの配信', 'https://www.apple.com/legal/privacy/', 'apple.com/legal/privacy'],
                  ].map(([name, purpose, url, label], i) => (
                    <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="px-3 py-2 border border-gray-200 font-medium whitespace-nowrap">{name}</td>
                      <td className="px-3 py-2 border border-gray-200">{purpose}</td>
                      <td className="px-3 py-2 border border-gray-200">
                        <a href={url} target="_blank" rel="nofollow noopener noreferrer" className="hover:underline" style={{ color: '#102A43' }}>{label}</a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Section>

          <Section title="4. データの保持期間">
            <ul className="space-y-1.5 pl-4">
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">アカウント情報</strong>：退会・削除申請から30日以内に削除</span></li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">業務データ</strong>：最終利用日から1年間保持後に削除</span></li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">OCR処理用画像データ</strong>：処理完了後、即時削除（サーバーに保存しません）</span></li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">アクセスログ</strong>：90日間保持後に自動削除</span></li>
            </ul>
          </Section>

          <Section title="5. データの削除方法">
            <p>
              アカウントおよび関連データの削除をご希望の場合は、<a href="mailto:support@ai-noki.com" className="font-medium hover:underline" style={{ color: '#102A43' }}>support@ai-noki.com</a> までご連絡ください。本人確認後、30日以内に対応いたします。
            </p>
          </Section>

          <Section title="6. Cookie・トラッキング技術">
            <ul className="space-y-1.5 pl-4 mb-3">
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">必須Cookie</strong>：セッション管理・セキュリティ</span></li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">分析Cookie</strong>：サービス利用状況の把握・改善</span></li>
            </ul>
            <p>iOSアプリでは、Appleが定めるApp Tracking Transparency（ATT）フレームワークに基づき、ユーザーの同意を得た上でのみトラッキングを行います。</p>
          </Section>

          <Section title="7. ユーザーの権利">
            <p className="mb-3">ユーザーは以下の権利を有します。</p>
            <ul className="space-y-1.5 pl-4 mb-3">
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">開示請求</strong>：保有する個人情報の確認を求める権利</span></li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">訂正・削除請求</strong>：不正確な情報の訂正、または情報の削除を求める権利</span></li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">利用停止請求</strong>：個人情報の利用の停止を求める権利</span></li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span><span><strong className="text-gray-800">同意の撤回</strong>：データ収集への同意をいつでも撤回する権利</span></li>
            </ul>
            <p>各種請求は <a href="mailto:support@ai-noki.com" className="font-medium hover:underline" style={{ color: '#102A43' }}>support@ai-noki.com</a> にご連絡ください。本人確認後、30日以内に対応いたします。</p>
          </Section>

          <Section title="8. 情報の保管・セキュリティ">
            <ul className="space-y-1.5 pl-4 mb-3">
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span>データの暗号化（転送時：TLS1.2以上、保管時）</li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span>アクセス権限の最小化</li>
              <li className="flex gap-2"><span className="text-gray-400 flex-shrink-0">・</span>定期的なセキュリティ監査</li>
            </ul>
            <p className="text-gray-500 text-xs">ただし、インターネット通信の性質上、完全なセキュリティを保証することはできません。</p>
          </Section>

          <Section title="9. 未成年者の利用">
            <p>本サービスは18歳以上の方を対象としています。18歳未満の方が個人情報を提供したことが判明した場合、速やかに削除いたします。</p>
          </Section>

          <Section title="10. 本ポリシーの変更">
            <p>運営者は、法令の変更やサービス内容の変更に伴い、本ポリシーを改定することがあります。重要な変更がある場合は、本ページへの掲示またはアプリ内通知でお知らせします。</p>
          </Section>

          <Section title="11. お問い合わせ">
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-2">
              {[
                ['サービス名', 'AI納期'],
                ['運営者', '個人事業主 小助川'],
                ['メールアドレス', 'support@ai-noki.com', true],
                ['受付時間', '平日 10:00〜18:00（土日祝・年末年始を除く）'],
              ].map(([label, value, isEmail], i) => (
                <div key={i} className="flex gap-3">
                  <span className="text-gray-500 w-28 flex-shrink-0 text-xs pt-0.5">{label}</span>
                  {isEmail ? (
                    <a href={`mailto:${value}`} className="font-medium hover:underline text-sm" style={{ color: '#102A43' }}>{value as string}</a>
                  ) : (
                    <span className="text-gray-800 text-sm">{value as string}</span>
                  )}
                </div>
              ))}
            </div>
          </Section>

          {/* Copyright */}
          <div className="pt-6 border-t border-gray-200 text-center text-xs text-gray-400">
            <p>制定日：2025年4月1日　／　最終更新日：2025年4月1日</p>
            <p className="mt-1">&copy; 2025 AI納期 / 個人事業主 小助川. All rights reserved.</p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-10">
        <div className="max-w-3xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center rounded" style={{ backgroundColor: '#102A43' }}>
              <i className="ri-time-line text-white" style={{ fontSize: '10px' }}></i>
            </div>
            <span className="text-sm font-semibold" style={{ color: '#102A43' }}>AI納期</span>
          </div>
          <div className="flex items-center gap-4 text-xs text-gray-500">
            <Link to="/privacy" className="hover:text-gray-800 cursor-pointer">プライバシーポリシー</Link>
            <span className="text-gray-300">|</span>
            <Link to="/terms" className="hover:text-gray-800 cursor-pointer">利用規約</Link>
            <span className="text-gray-300">|</span>
            <a href="mailto:support@ai-noki.com" className="hover:text-gray-800">お問い合わせ</a>
          </div>
          <p className="text-xs text-gray-400">&copy; 2025 個人事業主 小助川</p>
        </div>
      </footer>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="text-base font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
        {title}
      </h2>
      {children}
    </section>
  );
}
